import { render, staticRenderFns } from "./annexFile.vue?vue&type=template&id=e0bb3bd6&scoped=true"
import script from "./annexFile.vue?vue&type=script&lang=js"
export * from "./annexFile.vue?vue&type=script&lang=js"
import style0 from "./annexFile.vue?vue&type=style&index=0&id=e0bb3bd6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0bb3bd6",
  null
  
)

export default component.exports